// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DevicesFranquias_DisconnectDeviceResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/devices_franquias/disconnect_device
 *
 * Action endpoint — confirmation only; envelope `dados` is null.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type DevicesFranquias_DisconnectDeviceResponseDados = null;

export type DevicesFranquias_DisconnectDeviceResponse = ApiResponse<DevicesFranquias_DisconnectDeviceResponseDados>;

registerResponseContract('DevicesFranquias_DisconnectDeviceResponse', {})
